// eslint-disable-next-line import/no-extraneous-dependencies
import React, {
    HTMLAttributes,
    ReactElement, ReactNode, useEffect,
} from "react";

import {
    Active, Data, Over, useDroppable,
} from "@dnd-kit/core";
import classNames from "classnames";

export interface DroppableProps extends Omit<HTMLAttributes<HTMLDivElement>, "onDragOver"> {
    id: string;
    children?: ReactNode,
    data?: Data,
    dragOverClassName?: string;
    isDisabled?: boolean;
    onDragOver?: (over: Over, active: Active | null) => void;
}

const Droppable = React.forwardRef((
    args: DroppableProps,
    ref: React.ForwardedRef<HTMLElement>,
): ReactElement => {
    const {
        children,
        id,
        className,
        dragOverClassName,
        onDragOver,
        data,
        isDisabled,
        ...rest
    } = args;

    const { setNodeRef, over, active } = useDroppable({
        id,
        data,
        disabled: isDisabled,
    });

    useEffect(() => {
        if (over?.id === id && onDragOver) {
            onDragOver(over, active);
        }
    }, [over?.id]);

    const mergedRef = (element: HTMLElement | null) => {
        setNodeRef(element);
        if (typeof ref === "function") {
            ref(element);
        } else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = element;
        }
    };

    return (
        <div
            className={classNames(className, over?.id === id ? dragOverClassName : "")}
            ref={mergedRef}
            {...rest}
        >
            {children}
        </div>
    );
});
Droppable.defaultProps = {
    dragOverClassName: "",
};
export default Droppable;
